import { z } from "zod";
import { BaseEvent } from "./base";
export const PaywallPreviewGeneration_Start = BaseEvent.extend({
    name: z.literal("events.superwall.com.feature.PaywallPreview.Generation_Start"),
    event: z.object({
        paywall_id: z.number(),
        paywall_preview_id: z.string()
    })
});
export const PaywallPreviewGeneration_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.feature.PaywallPreview.Generation_Complete"),
    event: z.object({
        paywall_id: z.number(),
        paywall_preview_id: z.string()
    })
});
